
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 25,
  viewBox: "0 0 35 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M20.308 1H28.9c2.262.007 4.093 1.85 4.1 4.127v14.746c-.007 2.276-1.838 4.12-4.1 4.127H4.1C1.835 24 0 22.152 0 19.873V5.127C.007 2.851 1.838 1.007 4.1 1h8.592M5 16.5h23m-23 3h8m10-12h5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 1,
  r: 1,
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"35\" height=\"25\" viewBox=\"0 0 35 25\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g transform=\"translate(-264 -327) translate(265 327)\">\r\n                <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M20.308 1H28.9c2.262.007 4.093 1.85 4.1 4.127v14.746c-.007 2.276-1.838 4.12-4.1 4.127H4.1C1.835 24 0 22.152 0 19.873V5.127C.007 2.851 1.838 1.007 4.1 1h8.592M5 16.5L28 16.5M5 19.5L13 19.5M23 7.5L28 7.5\"/>\r\n                <circle cx=\"16\" cy=\"1\" r=\"1\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/credit-card.77de35b83fa679022f60ec61889b666c.svg"),
        {
          React: SvgCreditCard,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      